<template>
  <router-view/>
  <p class="app-version">Version: {{appVersion}}</p>
  <SpinnerIcon v-if="$store?.state?.isProcessing" />
</template>

<script>

import SpinnerIcon from "@/components/Common/Spinner.vue";
import pkg from "../package.json";
// import {APP_VERSION} from './custom-service-worker'
export default {
  name: 'PastDvirPanel',
  components: {SpinnerIcon},
  methods: {
    //
  },
  data() {
    return {
      appVersion: JSON.stringify(pkg.version).replace(/"/g, ''), // Placeholder for version
    };
  },
  mounted() {
    document.addEventListener('gesturestart', function(event) {
      event.preventDefault();
    });

    document.addEventListener('gesturechange', function(event) {
      event.preventDefault();
    });

    document.addEventListener('gestureend', function(event) {
      event.preventDefault();
    });


  }
}
</script>

<style>
#spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -50px;
  width: 100px;
  height: 100px;
}
html, body {
  -webkit-user-select: none; /* Chrome/Safari */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Standard */
  touch-action: manipulation; /* Prevent default gestures */
}
.app-wrapper {
  position: relative;
  min-height: 100vh;
  padding-bottom: 2.5rem; /* reserve space for version text */
}

.app-version {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.85rem;
  color: #333;
  z-index: -1;
  padding: 4px 12px;
  border-radius: 6px;
}
</style>